import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import DoDisturbOnOutlinedIcon from '@mui/icons-material/DoDisturbOnOutlined'
import { ReactNode } from 'react'

export const statusColours: Record<string, string> = {
  Requested: 'primary.main',
  // Shift-request "Accepted" reads as pending, so it shares the pending emphasis.
  Accepted: 'primary.main',
  Approved: 'success.main',
  // Softer red than error.main, matching the "Deleted shift" tag so the negative outcomes align.
  Declined: 'deactivate.main',
  Cancelled: 'cancel.main',
}

export const statusIconMap: Record<string, ReactNode> = {
  Requested: <DoDisturbOnOutlinedIcon />,
  Accepted: <DoDisturbOnOutlinedIcon />,
  Approved: <CheckCircleOutlineIcon />,
  Declined: <CancelOutlinedIcon />,
  Cancelled: <CancelOutlinedIcon />,
}

/**
 * Friendlier status labels, kept consistent with Leave & Unavailability. Both the leave
 * "Requested" and the shift-request "Accepted" (recipient accepted, awaiting manager review)
 * read as "Pending"; Approved/Declined/Cancelled fall through to their raw names.
 */
export const statusDisplayText: Record<string, string> = {
  Requested: 'Pending',
  Accepted: 'Pending',
}

/** Tab keys for the Approvals page; shared so filter options can react to the active tab. */
export const APPROVALS_TAB_KEYS = {
  leaveAndUnavailability: 'requests',
  shiftSwapping: 'shift-swapping',
} as const
